export const dummyExercises = [
  { id: 'e1', name: 'Barbell Back Squat', category: 'Strength', muscle: 'Legs', difficulty: 'Advanced', load: '85%', volume: '4,200kg' },
  { id: 'e2', name: 'Romanian Deadlift', category: 'Strength', muscle: 'Hamstrings', difficulty: 'Intermediate', load: '75%', volume: '3,800kg' },
  { id: 'e3', name: 'Weighted Pull-ups', category: 'Hypertrophy', muscle: 'Back', difficulty: 'Advanced', load: 'RPE 9', volume: '1,200kg' },
  { id: 'e4', name: 'Incline Dumbbell Press', category: 'Hypertrophy', muscle: 'Chest', difficulty: 'Intermediate', load: 'RPE 8', volume: '2,400kg' },
  { id: 'e5', name: 'Kettlebell Swings', category: 'Conditioning', muscle: 'Full Body', difficulty: 'Beginner', load: 'EMOM', volume: 'N/A' },
  { id: 'e6', name: 'Box Jumps', category: 'Plyometric', muscle: 'Legs', difficulty: 'Intermediate', load: 'Max Power', volume: 'N/A' },
  { id: 'e7', name: 'Assault Bike Sprint', category: 'Cardio', muscle: 'Full Body', difficulty: 'All Levels', load: '90% HR', volume: 'N/A' },
  { id: 'e8', name: 'Bulgarian Split Squat', category: 'Strength', muscle: 'Legs', difficulty: 'Advanced', load: '70%', volume: '1,800kg' },
];

export const coachNotes = [
  "Focus on eccentric control during squats today. Keep it to 3 seconds down.",
  "Your CNS readiness is at 82% - green light for heavy pulls.",
  "Remember to pack your lifting belt for the top sets.",
];

export const gearList = [
  { item: 'Lifting Shoes', packed: true, id: 1 },
  { item: 'Chalk', packed: false, id: 2 },
  { item: 'Wrist Wraps', packed: true, id: 3 },
  { item: 'Electrolyte Mix', packed: false, id: 4 },
];

export const progressData = {
  dates: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  volume: [12000, 14500, 0, 16000, 11000, 8000, 0],
  intensity: [75, 82, 0, 91, 65, 50, 0],
  heartRate: [62, 65, 58, 68, 64, 60, 59]
};

export const demoSteps = [
  { 
    id: 'setup', 
    title: '01. Parameter Baseline', 
    desc: 'Initialize your biometric profile and movement capacity benchmarks.',
    status: 'success'
  },
  { 
    id: 'build', 
    title: '02. Sequence Logic', 
    desc: 'Use the Constructor to bridge exercise nodes into a high-performance routine.',
    status: 'in-progress'
  },
  { 
    id: 'schedule', 
    title: '03. Matrix Integration', 
    desc: 'Map your routine to the temporal grid for consistent execution.',
    status: 'pending'
  },
  { 
    id: 'execute', 
    title: '04. Live Telemetry', 
    desc: 'Track metrics in real-time during live training sessions.',
    status: 'pending'
  },
  { 
    id: 'analyze', 
    title: '05. Data Synthesis', 
    desc: 'Review load trajectories and CNS recovery trends.',
    status: 'pending'
  },
  { 
    id: 'adapt', 
    title: '06. Neural Scaling', 
    desc: 'System automatically adjusts next session load based on fatigue.',
    status: 'pending'
  },
  { 
    id: 'outcome', 
    title: '07. Performance Peak', 
    desc: 'Reach consistent hypertrophy goals through data-backed consistency.',
    status: 'pending'
  }
];

export const faqData = [
  {
    q: "How does FitSync Lab track CNS readiness?",
    a: "We analyze heart rate variability (HRV) and sleep latency metrics from your connected wearables to calculate a neural recovery score before each session."
  },
  {
    q: "Is this data real or simulated in the demo?",
    a: "The current interface uses high-fidelity simulated records to demonstrate the 'Control Room' experience. Real-world accounts sync via encrypted API bridges."
  },
  {
    q: "Can I use this for powerlifting or just hypertrophy?",
    a: "FitSync Lab supports multiple 'Logic Engines'. You can switch between Hypertrophy Alpha, Strength Matrix, or Conditioning Flux depending on your primary goal."
  },
  {
    q: "Is my biometric data private?",
    a: "Data is processed locally within your session. In production, we use end-to-end encryption. This demo does not store or transmit any private information."
  },
  {
    q: "How do I upgrade from the Beta version?",
    a: "Enterprise access and advanced neural scaling modules are available through our partnership channels at LingLink AI and DigLab AI."
  }
];